import {useGetAndSet} from "./useGetAndSet";
import {createSetMovementTypesDataAction} from "../actions/dataActions";

export const useMovementTypesData = (params, dataFresh) => {
    return useGetAndSet("movementtype", params, createSetMovementTypesDataAction, dataFresh);
}